import React from "react";
import * as S from "./Interlinking.styles";

interface ArrayProps {
    text: string,
    url: string,
}

interface InterlinkingProps {
    topRoutes: Array<ArrayProps>,
    cityFrom: Array<ArrayProps>,
    cityTo: Array<ArrayProps>,
    airportRoutes: Array<ArrayProps>
}

export default function Interlinking(props: InterlinkingProps) {
    const { topRoutes = [], cityFrom = [], cityTo = [], airportRoutes = [] } = props;
    return (
        <S.InterlinkingContainer>
            <S.InterlinkingItem>
                <S.InterlinkingHeader>Top Cab Routes</S.InterlinkingHeader>
                <S.InterlinkingBody>
                    {topRoutes.map((item, index) => {
                        return (
                            <S.InterlinkingAnchor key={index} href={item?.url}>{item?.text}</S.InterlinkingAnchor>
                        )
                    })}
                </S.InterlinkingBody>
            </S.InterlinkingItem>
            <S.InterlinkingItem>
                <S.InterlinkingHeader>Cab from Top Cities</S.InterlinkingHeader>
                <S.InterlinkingBody>
                    {cityFrom.map((item, index) => {
                        return (
                            <S.InterlinkingAnchor key={index} href={item?.url}>{item?.text}</S.InterlinkingAnchor>
                        )
                    })}
                </S.InterlinkingBody>
            </S.InterlinkingItem>
            <S.InterlinkingItem>
                <S.InterlinkingHeader>Top Airport Cab Routes</S.InterlinkingHeader>
                <S.InterlinkingBody>
                    {airportRoutes.map((item, index) => {
                        return (
                            <S.InterlinkingAnchor key={index} href={item?.url}>{item?.text}</S.InterlinkingAnchor>
                        )
                    })}
                </S.InterlinkingBody>
            </S.InterlinkingItem>
        </S.InterlinkingContainer>
    );
}

